import React from 'react';
import { SubjectImagePreferences } from '../../../../services';
import { getTheme } from '@fluentui/react';

interface TextTypeProps {
  val: string;
  settings?: SubjectImagePreferences;
  isZoomInActive?: boolean;
  setColor?: boolean;
}

export const TextType: React.FunctionComponent<TextTypeProps> = (props): JSX.Element => {
  return (
    <div style={{ color: props.setColor ? getTheme().palette.white : 'inherit' }} className={'wordBreak px-3 pb-3'}>
      <>{props.settings?.isTextBlurred ? props.val?.replace(/./g, '*') : props.val}</>
    </div>
  );
};
